export default __webpack_public_path__ + "static/media/Veteran's Bag.9d9b7c85.jpg";